import { Configuration, PopupRequest } from "@azure/msal-browser";
const baseUri = document.getElementById('root')?.baseURI;

const clientId = process.env.REACT_APP_MSAL_CLIENT_ID;
if (!clientId) {
    throw new Error("REACT_APP_MSAL_CLIENT_ID is not set. Define it in the environment before building the app.");
}

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
    auth: {

        clientId: clientId,
        authority: "https://login.microsoftonline.com/a9d3abc9-3302-4217-8969-726e46809c6d",
        redirectUri:baseUri,
        postLogoutRedirectUri: "/"
    }
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
    scopes: ["User.Read"]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/beta/me",
    graphUsersEndpoint: "https://graph.microsoft.com/beta/users"
};
